import React from 'react';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import SortableTh from 'src/components/SortableTh';
import { EMPLOYEE_ATTENDANCE_EDIT } from 'src/constants/EndpointUrls';
import { takePaysSearchQueries, FORM_NAME_ATTENDANCES_SEARCH } from 'src/reducers/searchForm';
import { getList } from 'src/reducers/common/listReducer';
import { REDUCER_NAME } from 'src/reducers/employees/employeeAttendances';
import { redirectTo, detailUrlWithQueries, getIdsFromArr } from 'src/utils/Http';
import EmployeeAttendanceTableRow from '../components/EmployeeAttendanceTableRow';
import { useTranslation } from 'react-i18next';

const EmployeeAttendanceTable = ({ employeeAttendances, queries }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="l-overflow-scroll">
      <table className="m-table-list">
        <thead>
          <tr>
            <th>{t('features.EmployeeBonus.components.EmployeeBonusTable.note')}</th>
            <SortableTh
              field="staffCode"
              globalClassName="m-table-list-staffcode"
              formName={FORM_NAME_ATTENDANCES_SEARCH}
            >
              {t('features.EmployeePays.components.DownloadColumnDetail.staff_code')}
            </SortableTh>
            <SortableTh field="name" formName={FORM_NAME_ATTENDANCES_SEARCH}>
              {t('features.EmployeeBonus.ShowBonusFbDataPage.name')}
            </SortableTh>
            <SortableTh field="attendanceUpdatedAt" formName={FORM_NAME_ATTENDANCES_SEARCH}>
              {t('features.EmployeeAttendances.containers.EmployeeAttendanceTable.Latest_attendance_update')}
            </SortableTh>
            <th>{t('features.EmployeeAttendances.containers.EmployeeAttendanceTable.Attendance_link')}</th>
          </tr>
        </thead>
        <tbody>
          {(!employeeAttendances || employeeAttendances.length === 0) && (
            <tr>
              <td colSpan={5}>{t('features.ClientCsvFormats.components.ClientCsvFormatsTable.no_data')}</td>
            </tr>
          )}
          {employeeAttendances.map(employeeAttendance => (
            <EmployeeAttendanceTableRow
              key={employeeAttendance.id}
              onClick={() =>
                redirectTo(
                  detailUrlWithQueries(
                    employeeAttendance.id,
                    queries,
                    EMPLOYEE_ATTENDANCE_EDIT,
                    getIdsFromArr(employeeAttendances)
                  )
                )
              }
              employeeAttendance={employeeAttendance}
              i18n={i18n}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  employeeAttendances: getList(REDUCER_NAME, state),
  queries: takePaysSearchQueries(getFormValues(FORM_NAME_ATTENDANCES_SEARCH)(state))
});
export default connect(mapStateToProps)(EmployeeAttendanceTable);
